import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';

import { Title } from 'src/onboarding/components/typography/Title/Title';

import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const successVisualization = useStore((state) => state.successVisualization);
  const setSuccessVisualization = useStore((state) => state.setSuccessVisualization);
  const { onNext, onPrev, currentIndex } = useNav();


  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.successVisualization.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={successVisualization}
          onChange={(value) => {
            setSuccessVisualization(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'success-visualization',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={"Strong willpower"}>
            <span>💪</span> {t('onboarding.successVisualization.options.willpower')}
          </Option>
          <Option value={"Structure and planning"}>
            <span>📅</span> {t('onboarding.successVisualization.options.structure')}
          </Option>
          <Option value={"Healthy habits"}>
            <span>🥦</span> {t('onboarding.successVisualization.options.habits')}
          </Option>
          <Option value={"Support system"}>
            <span>💞</span> {t('onboarding.successVisualization.options.support')}
          </Option>
          <Option value={"I’m not sure"}>
            <span>🤔</span> {t('onboarding.successVisualization.options.notSure')}
          </Option>
        </Check>
      </div>
    </div>
  );
}

export default Page;
